import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(even)': {
        backgroundColor: '#F8F8F8',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
export default StyledTableRow;
